import { ReactNode, useEffect, useMemo, useState } from "react";
import ShSidebar from "../components/ShSidebar";
import ShNavbar from "../components/ShNavbar";
import { MenuApi } from "../api/MenuApi";
import { useMutation } from "@tanstack/react-query";
import { useRouterState } from "@tanstack/react-router";
import { Routes } from "../utils/costants/routes";

import NotificationModal from "../components/NotificationModal";
import NotificationDrawer from "../components/drawers/NotificationDrawer";
import { useGetNotifications } from "../hooks/useGetNotifications";
import { useReadNotification } from "../hooks/useReadNotification";

interface SideBarLayoutProps {
  children: ReactNode;
}

export default function SidebarLayout({ children }: SideBarLayoutProps) {
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);

  const [openModal, setOpenModal] = useState({
    title: "",
    body: "",
    cta_label: "",
    isOpen: false,
  });
  const [navItems, setNavItems] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openNotificationDrawer, setOpenNotificationDrawer] = useState(false);

  const routerState = useRouterState();

  const { data: notificationData, isLoading: isNotificationLoading } =
    useGetNotifications();

  const { mutation: readNotification } = useReadNotification();

  const mutation = useMutation({
    mutationFn: () => MenuApi.getDynamicMenu(),
    onError: (error) => {
      console.log(error);
    },
    onSuccess: (success) => {
      setNavItems(success.data.menu);
      setIsLoading(false); // Nascondi il loader dopo il completamento della richiesta
    },
    onMutate: () => {
      setIsLoading(true); // Mostra il loader prima dell'avvio della richiesta
    },
  });

  useEffect(() => {
    mutation.mutate();
  }, []);

  const pathname = routerState.location.pathname;

  const { showBack, showBreadcrumb, showStatsBreadcrumb, showCampaignBreadcrumb } =
    useMemo(() => {
      const isClientProfile =
        pathname === Routes.CLIENT_PROFILE ||
        pathname.startsWith(`${Routes.CLIENT_PROFILE}/`);

      return {
        showBack: isClientProfile,
        showBreadcrumb: pathname === Routes.REVIEW_PAGE,
        showStatsBreadcrumb: pathname === Routes.STATISTICHE,
        showCampaignBreadcrumb: pathname === Routes.ADV,
      };
    }, [pathname]);

  return (
    <div className="flex flex-row w-full h-screen overflow-hidden transition-opacity duration-500 ease-in-out">
      <NotificationModal
        isOpen={openModal.isOpen}
        closeModal={() =>
          setOpenModal((prev) => ({
            ...prev,
            isOpen: false,
          }))
        }
        title={openModal.title}
        description={openModal.body}
      />
      <NotificationDrawer
        open={openNotificationDrawer}
        isLoading={isNotificationLoading}
        onClose={function (): void {
          setOpenNotificationDrawer(false);
        }}
        notifications={notificationData ?? []}
        onNotificationClick={(data) => {
          readNotification.mutate({
            id: data.id_notify,
          });
          setOpenModal((prev) => ({
            ...prev,
            title: data.title ?? "",
            body: data.body ?? "",
            isOpen: true,
          }));
        }}
      />
      <div className="flex w-full h-screen max-w-full overflow-x-hidden ">
        <ShSidebar
          onBackdropClick={() => setIsSideNavOpen(false)}
          isSideNavOpen={isSideNavOpen}
          navBarItems={navItems}
          isLoading={isLoading}
          currentRoot={pathname}
        />
        <div className="relative flex flex-col w-full h-full overflow-x-hidden overflow-y-hidden ">
          <ShNavbar
            showBreadcrumb={showBreadcrumb}
            showStatsBreadcrumb={showStatsBreadcrumb}
            showBack={showBack}
            showCampaignBreadcrumb={showCampaignBreadcrumb}
            onDrawerBtnClick={() => setIsSideNavOpen(!isSideNavOpen)}
            isSideNavOpen={isSideNavOpen}
            unreadNotificationCount={
              notificationData?.filter(
                (notificationData) => notificationData.read_date === null
              ).length ?? 0
            }
            onNotificationClick={() => setOpenNotificationDrawer(true)}
          />
          {children}
        </div>
      </div>
    </div>
  );
}
